import { ClientApiContextData } from "../ClientApiContext";
import { FEATURE_FLAGS_ENUM } from "../featureFlags";
import { Maybe } from "../queries";

export const isPreloadDisabled = (
  clientApiContext: ClientApiContextData | null,
  featureFlags: Maybe<string>[]
) => {
  // Tizen have issue with preload video (black flash on current video)
  const isTizenPlayer = clientApiContext?.playbackConfig.isTizenPlayer;

  const isDisablePreloadVideoByFeatureFlag = featureFlags.includes(
    FEATURE_FLAGS_ENUM.DISABLE_PRELOAD_VIDEO
  );

  if (isTizenPlayer || isDisablePreloadVideoByFeatureFlag) return true;

  return false;
};
